<template>
  <div>
    <div class="container content">
      <span class="back" @click="goBack">
        <font-awesome-icon icon="angle-left"/>
        <span>Вернуться к выбору группы</span>
      </span>

      <h1 class="center">Выберите участника</h1>
      <app-search @change="handleFilter"></app-search>

      <div class="no-players" v-if="filter.length==0 && this.players.length==0">
        <div class="text">
          В этой группе нет ни одного участника.
        </div>
      </div>

      <div class="relative">
        <loader ref="loader"/>
        <div class="no-players" v-if="filter.length!=0 && this.filteredPlayers.length==0">
          <div class="text">
            По данному запросу никого не найдено.
          </div>
        </div>
        <div class="grid">
          <div class="row">
            <div class="col-2 col-1-xs" v-for="player in filteredPlayers" :key="player.id">
              <div class="btn" @click="setPlayer(player)">{{player.last_name}} {{player.first_name}}
                {{player.middle_name}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination @change="setPage" :itemsPerPage="itemsPerPage" :resultCount="resultCount" ref="pagination"/>
    </div>
  </div>
</template>

<script>
  import PlayersService from '@/services/PlayersService'

  export default {
    name: 'start-player',
    data () {
      return {
        players: [],
        filteredPlayers: [],
        filter: '',
        currentPage: 1,
        itemsPerPage: 8,
        resultCount: 0
      }
    },
    computed: {
      groupId () {
        return this.$store.getters.groupId
      }
    },
    methods: {
      goBack () {
        this.$emit('setPage', 2)
      },
      setPlayer (player) {
        this.$emit('setPage', 4)
        this.$store.dispatch('setPlayer', player)
      },
      handleFilter: function (filter) {
        this.filter = filter
        this.currentPage = 1
        this.$refs.pagination.setPage(1)

        this.filteredPlayers = this.players.filter((player) => {
          let fio = player.last_name + ' ' + player.first_name
          if (player.middle_name) {
            fio += ' ' + player.middle_name
          }
          return fio.toLowerCase().includes(filter.toLowerCase())
        })

        this.resultCount = this.filteredPlayers.length

        this.filteredPlayers = this.filteredPlayers.slice(0, this.itemsPerPage)
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        let index = this.currentPage * this.itemsPerPage - this.itemsPerPage
        this.filteredPlayers = this.players.slice(index, index + this.itemsPerPage)
      },
      getPlayers () {
        this.$refs.loader.show()
        PlayersService.getPlayersByGroupId(this.groupId).then(
          (response) => {
            this.players = response
            this.resultCount = this.players.length
            this.filteredPlayers = this.players.slice(0, this.itemsPerPage)
            this.$refs.loader.hide()
          }
        )
      }
    },
    mounted () {
      this.getPlayers()
    }
  }
</script>

<style scoped lang="scss">
  .content {
    min-height: calc(100vh - 212px);
  }

  .col-2 {
    margin: 7px 0;
    .btn {
      padding: 25px 20px;
      @media screen and (max-width: 500px) {
        font-size: 14px;
        height: auto;
        padding: 10px;
        font-weight: 400;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/game/StartPlayer.vue